import isInKwaiying from '../isInKwaiying';
import openUrl from './openUrl';
import { getMarketUrl, getToAppName } from './base';
import getDeviceInfo from '../getDeviceInfo';
import onVisibleChange from '../onVisibleChange';
import getDefer from '../getDefer';
import getVisible from '../getVisible/index.web';
import getAppName from '../getAppName';
import openMarket from './openMarket';
import isIphone from '../isIphone';
let tipEl;
export function showTip(shareTipImg, callback) {
    if (tipEl) {
        tipEl.style.display = 'block';
    }
    else {
        tipEl = document.createElement('div');
        // better performance then set style attributes
        // eslint-disable-next-line max-len
        tipEl.style.cssText = `position:fixed;top:0;left:0;right:0;bottom:0;background-image:url(${shareTipImg});background-color:rgba(0,0,0,0.4);background-size:contain;background-repeat:no-repeat;z-index:9999`;
        tipEl.id = 'img-tip';
        document.body.appendChild(tipEl);
        tipEl.addEventListener('click', () => {
            tipEl.style.display = 'none';
            callback && callback();
            return false;
        }, false);
    }
}
export function openBrowserTip(callback) {
    showTip(isIphone()
        ? 'https://ali2.a.kwimgs.com/udata/pkg/kmovie/share_tip_open.png'
        : 'https://ali2.a.kwimgs.com/udata/pkg/kmovie/android.aa9c0a1a5ed55f61.png', callback);
}
let toastEl;
function showToast(text = '正在打开应用...') {
    if (toastEl) {
        toastEl.style.display = 'flex';
    }
    else {
        toastEl = document.createElement('div');
        // better performance then set style attributes
        // eslint-disable-next-line max-len
        toastEl.style.cssText =
            'position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.4);z-index:9999;justify-content: center;align-items: center;color: #fff;display: flex;';
        toastEl.id = 'toast-el';
        toastEl.innerHTML = `
            <div style="height: 44px;line-height: 44px;background-color:#222;border-radius: 22px;padding: 0 16px;font-size:10px;">${text}</div>
        `;
        document.body.appendChild(toastEl);
    }
}
function hideToast() {
    toastEl && (toastEl.style.display = 'none');
}
async function openIframeSchema(url, toAppName, fallbackMarket, marketOption) {
    showToast();
    let timer;
    let opened = false;
    const sub = onVisibleChange((visible) => {
        if (!visible) {
            hideToast();
            defer.resolve(true);
            opened = true;
        }
        if (timer) {
            timer = clearTimeout(timer);
        }
        sub.remove();
    }, 0);
    const defer = getDefer();
    openUrl(url);
    timer = setTimeout(() => {
        sub.remove();
        const visible = getVisible();
        hideToast();
        if (opened || !visible) {
            defer.resolve(true);
            return;
        }
        const appName = getAppName();
        if (fallbackMarket && toAppName && appName === 'UNKNOWN') {
            openMarket(toAppName, marketOption);
            defer.resolve(false);
            return;
        }
        defer.resolve(false);
        openBrowserTip();
    }, 3000);
    return defer.promise;
}
/**
 * 打开scheme，去应用商店的情况会丢失链接
 * @param url
 * @returns
 */
async function openAppScheme(url, _OpenOptions) {
    const { appName, isMobile, globalId } = await getDeviceInfo();
    const encodedURI = encodeURIComponent(url);
    const toAppName = _OpenOptions?.toAppName || getToAppName(url);
    const markets = getMarketUrl(toAppName);
    const iosUniversalUrl = markets.getULink?.(url) || url;
    const yingyongbao = `${markets.yingyongbao}${url ? '&android_schema=' + encodedURI : ''}`;
    const isIos = isIphone();
    const marketOption = {
        schema: url,
        from: _OpenOptions?.lxFrom || _OpenOptions?.from,
        type: _OpenOptions?.lxType,
        content: _OpenOptions?.lxContent,
        egid: _OpenOptions?.lxEgid || globalId,
        use32: _OpenOptions?.use32,
    };
    if (!isMobile) {
        return openMarket(toAppName, marketOption);
    }
    const isDisableJump = ['wechat', 'qq', 'weibo'].includes(appName);
    if (isIos) {
        if (isDisableJump) {
            // 无解， 打开tip
            if (url) {
                openBrowserTip();
                return;
            }
            else {
                // 不指定链接，直接打开应用商店
                return openMarket(toAppName, marketOption);
            }
        }
        else {
            // 优先用UniversalUrl，没安装会去商店
            return openIframeSchema(iosUniversalUrl);
        }
    }
    // android
    if (['wechat', 'qq'].includes(appName)) {
        // 腾讯系优先用应用宝，一般不会失败， 其他走market，再不行会抛包
        return openIframeSchema(yingyongbao);
    }
    else {
        // 优先直接打开，失败了去应用商店
        return openIframeSchema(url, toAppName, true, marketOption);
    }
}
export default async function (url, _OpenOptions) {
    if (isInKwaiying() ||
        ['ksnebula', 'kwai'].includes(getAppName()) ||
        url.startsWith('http')) {
        openUrl(url, _OpenOptions);
        return;
    }
    return openAppScheme(url, _OpenOptions);
}
